module.exports = __webpack_public_path__ + "media/bootstrap-icons/lightning-charge-0e3cdeb5.svg";